module.exports = __webpack_public_path__ + "static/media/36-6.68add2df.mp3";